import React, { useContext, useEffect, useRef, useState } from "react";
import { Carousel, message, Skeleton } from "antd";
import axios from "axios";
import Modal from "react-modal";
import { BiChevronDown } from "react-icons/bi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import image from "../public/texture2.png";
import logo from "../public/logo128.png";
import logo1 from "../public/maranco.png";
import LoginRegister from "../Login/LoginRegister";
import SuccessLogin from "../Modal/Success Login";
import Submenu from "../profile/Submenu";
import { StateApp } from "../context/Context";
import { url } from "../url";
import icon1 from "./public/svgexport-10.svg";
import icon2 from "./public/svgexport-11.svg";
import icon3 from "./public/svgexport-9.svg";
import TransactionIcon from "./public/Transaction.svg";
import "./Header.css";

Modal.setAppElement("#root");

const getCarImageUrl = (fileName) => {
    if (!fileName) return "";
    return `${url}/${String(fileName).replace(/^\/+/, "")}`;
};

const getResponsiveSettings = (itemCount, currentSlide, setCurrentSlide) => {
    const count = Math.max(itemCount, 1);

    return {
        dots: itemCount > 1,
        infinite: itemCount > 6,
        speed: 420,
        slidesToShow: Math.min(6, count),
        slidesToScroll: Math.min(3, count),
        initialSlide: Math.min(currentSlide, Math.max(itemCount - 1, 0)),
        swipeToSlide: true,
        draggable: true,
        beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(3, count),
                    slidesToScroll: 1,
                    infinite: itemCount > 3,
                    dots: itemCount > 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: Math.min(2, count),
                    slidesToScroll: 1,
                    infinite: itemCount > 2,
                    dots: itemCount > 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: itemCount > 1,
                    dots: itemCount > 1,
                },
            },
        ],
    };
};

const Header = () => {
    const {
        openLogin,
        setOpenlogin,
        showSuccessLogin,
    } = useContext(StateApp);

    const navigate = useNavigate();
    const imageRequestRef = useRef(0);
    const mountedRef = useRef(true);

    const [selectedImage, setSelectedImage] = useState("");
    const [currentSlide, setCurrentSlide] = useState(0);
    const [carName, setCarName] = useState("");
    const [heroLoading, setHeroLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [subMenu, setSubmenu] = useState(false);
    const [carInfo, setCarInfo] = useState([]);
    const [carsLoading, setCarsLoading] = useState(true);

    const { userInfo } = useSelector((state) => state.userinformation);
    const { name, accessToken, mobile, loginInfo } = userInfo;
    const [token, setToken] = useState();

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
            imageRequestRef.current += 1;
        };
    }, []);

    useEffect(() => {
        setToken(accessToken);
    }, [accessToken]);

    useEffect(() => {
        let carouselFallbackTimer;

        const loadCars = async () => {
            setCarsLoading(true);

            try {
                const response = await axios.get(`${url}/cars/v1/get-car-list-without-paginate`);
                if (!mountedRef.current) return;

                const cars = Array.isArray(response?.data?.data) ? response.data.data : [];

                if (!cars.length) {
                    setCarInfo([]);
                    setHeroLoading(false);
                    setCarsLoading(false);
                    return;
                }

                const firstCar = cars.find((car) => car?.photo?.fileName) || cars[0];
                const firstImage = getCarImageUrl(firstCar?.photo?.fileName);
                setCarName(firstCar?.name || "خودرو");

                // Give the hero image a short head start before thumbnails begin downloading.
                // If it is slow, show the carousel anyway so the UI never feels blocked.
                carouselFallbackTimer = window.setTimeout(() => {
                    if (!mountedRef.current) return;
                    setCarInfo(cars);
                    setCarsLoading(false);
                }, 650);

                if (!firstImage) {
                    window.clearTimeout(carouselFallbackTimer);
                    setCarInfo(cars);
                    setCarsLoading(false);
                    setHeroLoading(false);
                    return;
                }

                setHeroLoading(true);
                const loader = new Image();
                if ("fetchPriority" in loader) loader.fetchPriority = "high";

                loader.onload = async () => {
                    try {
                        if (typeof loader.decode === "function") await loader.decode();
                    } catch (_) {
                        // The browser can still display an already loaded image if decode() fails.
                    }

                    if (!mountedRef.current) return;
                    window.clearTimeout(carouselFallbackTimer);
                    setSelectedImage(firstImage);
                    setHeroLoading(false);
                    setCarInfo(cars);
                    setCarsLoading(false);
                };

                loader.onerror = () => {
                    if (!mountedRef.current) return;
                    window.clearTimeout(carouselFallbackTimer);
                    setSelectedImage(firstImage);
                    setHeroLoading(false);
                    setCarInfo(cars);
                    setCarsLoading(false);
                };

                loader.src = firstImage;
            } catch (error) {
                if (!mountedRef.current) return;
                setHeroLoading(false);
                setCarsLoading(false);

                if (error?.message === "Network Error") {
                    message.error("خطا در اتصال به اینترنت!");
                } else {
                    message.error("خطا در دریافت خودروها. دوباره امتحان کنید.");
                }
            }
        };

        loadCars();

        return () => {
            if (carouselFallbackTimer) window.clearTimeout(carouselFallbackTimer);
        };
    }, []);

    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            padding: 0,
            transform: "translate(-50%, -50%)",
            position: "absolute",
            borderRadius: "10px",
            outline: "none",
            border: "none",
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
    };

    const showModal = () => {
        setIsModalOpen(true);
        setOpenlogin(true);
    };

    const handleCancel = () => setIsModalOpen(false);
    const showSubmenu = () => setSubmenu((previous) => !previous);

    const selectCar = (imgFile, nextCarName) => {
        const nextImage = getCarImageUrl(imgFile);
        if (!nextImage || nextImage === selectedImage) return;

        const requestId = ++imageRequestRef.current;
        const loader = new Image();
        if ("fetchPriority" in loader) loader.fetchPriority = "high";

        setHeroLoading(true);

        loader.onload = async () => {
            try {
                if (typeof loader.decode === "function") await loader.decode();
            } catch (_) {
                // Keep the already loaded image usable even if decode() rejects.
            }

            if (!mountedRef.current || requestId !== imageRequestRef.current) return;
            setSelectedImage(nextImage);
            setCarName(nextCarName || "خودرو");
            setHeroLoading(false);
        };

        loader.onerror = () => {
            if (!mountedRef.current || requestId !== imageRequestRef.current) return;
            setHeroLoading(false);
            message.error("تصویر خودرو بارگذاری نشد. دوباره امتحان کنید.");
        };

        loader.src = nextImage;
    };

    const carouselSettings = getResponsiveSettings(carInfo.length, currentSlide, setCurrentSlide);

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleCancel}
                style={customStyles}
                className="modalMobile"
            >
                <button className="custom-modal-close" onClick={handleCancel} aria-label="بستن">
                    &times;
                </button>
                {openLogin ? <LoginRegister /> : showSuccessLogin ? <SuccessLogin /> : null}
            </Modal>

            <header className="Header" style={{ backgroundImage: `url(${image})` }}>
                <div>
                    <nav className="md:hidden flex justify-between mr-6 z-10" aria-label="منوی اصلی">
                        <ul className="HeaderList my-[32px] flex items-center !mr-0">
                            <li>
                                <a href="https://marankoo.ir/" aria-label="مارانکو">
                                    <img className="w-[64px]" src={logo} alt="مارانکو" width="64" height="64" />
                                </a>
                            </li>
                            <li className="cursor-pointer text-nowrap"><a href="https://marankoo.ir/">صفحه اصلی</a></li>
                            <li className="cursor-pointer"><a href="https://marankoo.ir/blog/">بلاگ</a></li>
                            <li className="cursor-pointer text-nowrap"><a href="/rules">قوانین</a></li>
                            <li className="cursor-pointer text-nowrap"><a href="https://marankoo.ir/about-us/">درباره ما</a></li>
                        </ul>

                        <ul className="select-none items-center cursor-pointer HeaderList col-span-1 justify-end gap-2 my-[32px]">
                            <li onClick={() => navigate("/transactions")} className="flex text-nowrap gap-[16px] ml-[10px]">
                                <img src={TransactionIcon} alt="" className="HeaderIcons" width="24" height="24" />
                                تراکنش ها
                            </li>
                            <li onClick={() => navigate("/support")} className="flex text-nowrap gap-[16px] ml-[10px]">
                                <img src={icon1} alt="" className="HeaderIcons" width="24" height="24" />
                                پشتیبانی
                            </li>
                            <li onClick={() => navigate("/passengersTrips")} className="flex text-nowrap gap-[16px] ml-[10px]">
                                <img src={icon2} alt="" className="HeaderIcons" width="24" height="24" />
                                سفرهای شما
                            </li>
                            <div className={`${loginInfo ? "" : "hidden"} z-10`}>
                                {!token ? (
                                    <li onClick={showModal} className="flex gap-[16px] ml-[10px]">
                                        <img src={icon3} alt="" className="HeaderIcons" width="24" height="24" />
                                        <p>ورود به حساب کاربری</p>
                                    </li>
                                ) : (
                                    <div className="relative">
                                        <li onClick={showSubmenu} className="flex gap-[16px] ml-[32px] items-center">
                                            <img src={icon3} alt="" className="HeaderIcons" width="24" height="24" />
                                            <div className="flex gap-2 items-center">
                                                <p className="text-[16px] text-center justify-self-center">{name || mobile}</p>
                                                <BiChevronDown
                                                    style={{ fontSize: "32px" }}
                                                    className={`transform transition-transform duration-300 ${subMenu ? "rotate-180" : "rotate-0"}`}
                                                />
                                            </div>
                                        </li>
                                        {subMenu && (
                                            <div className="absolute left-2 w-[220px]">
                                                <div className="slide-down translate-y-6 transform-gpu">
                                                    <Submenu />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </ul>
                    </nav>

                    <div className="Handle">
                        <div className="flex justify-center pt-5">
                            <img className="w-[128px]" src={logo1} alt="مارانکو" width="128" height="128" />
                        </div>
                        <div className="absolute top-24 w-full">
                            <h2 className="text-[22px] text-white font-[500] mx-6 md:mt-10 text-center">
                                خودرو {carName || "مناسب"} برای سفرهای شما
                            </h2>
                        </div>
                        <div className="mobile-hero-image-wrap" aria-busy={heroLoading}>
                            {selectedImage ? (
                                <img
                                    src={selectedImage}
                                    alt={carName ? `خودرو ${carName}` : "خودرو سفر"}
                                    className={`hero-car mobile-hero-image ${heroLoading ? "is-loading" : ""}`}
                                    loading="eager"
                                    decoding="async"
                                    width="520"
                                    height="225"
                                    draggable="false"
                                    onLoad={() => setHeroLoading(false)}
                                    onError={() => setHeroLoading(false)}
                                />
                            ) : (
                                <div className="hero-car-placeholder" aria-hidden="true" />
                            )}
                        </div>
                    </div>

                    <div className="md:hidden grid grid-cols-2">
                        <div className="col-span-1">
                            {carName ? (
                                <h2 className="text-[32px] text-white font-[900] mx-[60px] my-6">
                                    خودرو {carName} مناسب سفرهای شما
                                </h2>
                            ) : (
                                <div className="mx-[60px] my-6 max-w-[430px]">
                                    <Skeleton active paragraph={false} />
                                </div>
                            )}
                        </div>
                        <div className="col-span-1">
                            <div className="desktop-hero-image-wrap" aria-busy={heroLoading}>
                                {selectedImage ? (
                                    <img
                                        src={selectedImage}
                                        alt={carName ? `خودرو ${carName}` : "خودرو سفر"}
                                        className={`hero-car desktop-hero-image ${heroLoading ? "is-loading" : ""}`}
                                        loading="eager"
                                            decoding="async"
                                        width="620"
                                        height="320"
                                        draggable="false"
                                        onLoad={() => setHeroLoading(false)}
                                        onError={() => setHeroLoading(false)}
                                    />
                                ) : (
                                    <div className="hero-car-placeholder" aria-hidden="true" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="header-cars-section" aria-label="انتخاب خودرو">
                {carsLoading && !carInfo.length ? (
                    <div className="header-cars-skeleton" aria-hidden="true">
                        {[0, 1, 2].map((item) => <span key={item} />)}
                    </div>
                ) : carInfo.length ? (
                    <Carousel
                        className="header-carousel"
                        autoplay={carInfo.length > 1}
                        autoplaySpeed={4800}
                        pauseOnHover
                        {...carouselSettings}
                    >
                        {carInfo.map((item, index) => {
                            const imageUrl = getCarImageUrl(item?.photo?.fileName);
                            const isSelected = Boolean(imageUrl && selectedImage === imageUrl);

                            return (
                                <div key={item?._id || imageUrl || index} className="flex justify-center items-center">
                                    <button
                                        type="button"
                                        className={`car-thumb-card md:w-[98%] relative w-[90%] h-[104px] rounded-[20px] bg-[#FFB800] mx-auto ${isSelected ? "car-thumb-card--selected" : ""}`}
                                        onClick={() => selectCar(item?.photo?.fileName, item?.name)}
                                        aria-label={`انتخاب خودرو ${item?.name || index + 1}`}
                                        aria-pressed={isSelected}
                                    >
                                        <span className="car-thumb-image-wrap">
                                            {imageUrl ? (
                                                <img
                                                    className="car-thumb-image"
                                                    src={imageUrl}
                                                    alt={item?.name ? `خودرو ${item.name}` : `خودرو ${index + 1}`}
                                                    loading="lazy"
                                                    decoding="async"
                                                    width="185"
                                                    height="84"
                                                    draggable="false"
                                                />
                                            ) : (
                                                <span className="car-thumb-fallback">بدون تصویر</span>
                                            )}
                                        </span>
                                    </button>
                                </div>
                            );
                        })}
                    </Carousel>
                ) : (
                    <p className="header-cars-empty">در حال حاضر خودرویی برای نمایش وجود ندارد.</p>
                )}
            </section>
        </>
    );
};

export default Header;
